// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34PR8","toggle":"styles_toggle__2qlvz","preview":"styles_preview__3nShe"};